
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"height":"18","width":"18"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"#4285f4","d":"M17.82 9.205c0-.639-.057-1.252-.164-1.841H9.18v3.481h4.844a4.14 4.14 0 01-1.796 2.716v2.259h2.908c1.702-1.567 2.684-3.875 2.684-6.615z"}}),_c('path',{attrs:{"fill":"#34a853","d":"M9.18 18c2.43 0 4.467-.806 5.956-2.18l-2.909-2.259c-.805.54-1.836.86-3.047.86-2.344 0-4.328-1.584-5.036-3.711H1.137v2.332A8.997 8.997 0 009.18 18z"}}),_c('path',{attrs:{"fill":"#fbbc05","d":"M4.144 10.71A5.41 5.41 0 013.862 9c0-.593.102-1.17.282-1.71V4.958H1.137A8.996 8.996 0 00.18 9c0 1.452.348 2.827.957 4.042z"}}),_c('path',{attrs:{"fill":"#ea4335","d":"M9.18 3.58c1.321 0 2.507.454 3.44 1.345l2.582-2.58C13.642.891 11.606 0 9.18 0a8.997 8.997 0 00-8.043 4.958L4.144 7.29c.708-2.127 2.692-3.71 5.036-3.71z"}})])
          )
        }
      }
    